<!-- path: src/views/Dashboard.vue -->
<template>
  <div class="p">
    <el-row :gutter="16">
      <!-- 左列：上传 / 提取&回写 -->
      <el-col :span="8">
        <el-card>
          <el-tabs v-model="leftTab">
            <!-- Tab 1：上传 -->
            <el-tab-pane label="上传账号文件" name="upload">
              <el-upload ref="uploader" :action="uploadUrl" :headers="uploadHeaders" :show-file-list="false"
                accept=".txt" :on-success="onUploadSuccess" :on-error="onUploadError">
                <el-button type="primary" icon="el-icon-upload2">选择并上传 .txt</el-button>
              </el-upload>
              <div v-if="lastUpload" style="margin-top:12px;">
                <el-alert :title="`批号：${lastUpload.batch_code}，导入：${lastUpload.imported}`" type="success" show-icon />
              </div>
            </el-tab-pane>

            <!-- Tab 2：提取&回写 + 按邮箱重置 -->
            <el-tab-pane label="提取 & 回写" name="pick">
              <el-form :model="pickForm" label-width="90px" size="small">
                <el-form-item label="限定批号">
                  <el-input v-model="pickForm.batchCode" placeholder="可空，限定某个批号" />
                </el-form-item>
                <el-form-item label="租约秒数">
                  <el-input-number v-model="pickForm.leaseSeconds" :min="30" :step="30" />
                  <span class="hint">（默认 600 秒）</span>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-download" @click="pickOne" :loading="picking">
                    提取一个未处理
                  </el-button>
                  <el-button @click="clearCurrent" :disabled="!current.email">清空</el-button>
                </el-form-item>
              </el-form>

              <el-divider />

              <div v-if="current.email">
                <el-descriptions title="当前账号" :column="1" size="small" border>
                  <el-descriptions-item label="Email">
                    <span style="word-break:break-all">{{ current.email }}</span>
                    <el-button size="mini" type="text" @click="copy(current.email)">复制</el-button>
                  </el-descriptions-item>
                  <el-descriptions-item label="批次ID">{{ current.batch_id }}</el-descriptions-item>
                  <el-descriptions-item label="状态">{{ current.state }}</el-descriptions-item>
                  <el-descriptions-item label="租约到期">
                    {{ fmt(current.lease_expire_at) }}
                    <el-tag :type="leaseRemain <= 0 ? 'danger' : 'info'" size="mini" style="margin-left:8px">
                      剩余：{{ leaseRemain > 0 ? leaseRemain + 's' : '已超时' }}
                    </el-tag>
                  </el-descriptions-item>
                </el-descriptions>

                <el-form label-width="90px" size="small" style="margin-top:12px">
                  <el-form-item label="失败原因">
                    <el-input v-model="failReason" placeholder="仅在标记失败时可填写（选填）" />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" icon="el-icon-check" @click="markCompleted" :loading="marking"
                      :disabled="!current.email">
                      标记完成
                    </el-button>
                    <el-button type="danger" icon="el-icon-close" @click="markFailed" :loading="marking"
                      :disabled="!current.email">
                      标记失败
                    </el-button>
                    <el-popconfirm title="重置为未处理？" @confirm="resetUnprocessed">
                      <el-button slot="reference" :disabled="!current.email">重置为未处理</el-button>
                    </el-popconfirm>
                  </el-form-item>
                </el-form>
              </div>
              <div v-else class="muted">还没提取到账号，点击“提取一个未处理”。</div>

              <el-divider></el-divider>

              <!-- 按邮箱重置小表单 -->
              <el-form :model="emailReset" label-width="90px" size="small">
                <el-form-item label="邮箱">
                  <el-input v-model="emailReset.email" placeholder="输入邮箱，精确匹配" />
                </el-form-item>
                <el-form-item label="目标状态">
                  <el-select v-model="emailReset.state" placeholder="选择状态">
                    <el-option label="未处理 (unprocessed)" value="unprocessed" />
                    <el-option label="已完成 (completed)" value="completed" />
                    <el-option label="失败 (failed)" value="failed" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="warning" @click="resetEmail" :disabled="!emailReset.email || !emailReset.state">
                    按邮箱重置
                  </el-button>
                </el-form-item>
              </el-form>

            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>

      <!-- 右列：状态表 + 导出 -->
      <el-col :span="16">
        <!-- 运行状态 -->
        <el-card>
          <div slot="header" class="flex">
            <span>运行状态</span>
            <div>
              <el-button size="mini" @click="fetchStatus" icon="el-icon-refresh">刷新</el-button>
              <el-button size="mini" type="warning" @click="reapLeases" icon="el-icon-time">
                回收超时租约
              </el-button>
            </div>
          </div>

          <el-descriptions title="全局统计" :column="5" size="small" border>
            <el-descriptions-item label="Total">{{ global.total }}</el-descriptions-item>
            <el-descriptions-item label="Unprocessed">{{ global.unprocessed }}</el-descriptions-item>
            <el-descriptions-item label="Reserved">{{ global.reserved }}</el-descriptions-item>
            <el-descriptions-item label="Reserved Expired">{{ global.reserved_expired }}</el-descriptions-item>
            <el-descriptions-item label="Completed">{{ global.completed }}</el-descriptions-item>
            <el-descriptions-item label="Failed">{{ global.failed }}</el-descriptions-item>
          </el-descriptions>

          <el-table v-loading="loading" :data="batches" size="small" style="width:100%;margin-top:12px;">
            <el-table-column prop="batch_code" label="批号" width="160" />
            <el-table-column prop="created_at" label="创建时间" width="180">
              <template slot-scope="scope">
                {{ fmt(scope.row.created_at) }}
              </template>
            </el-table-column>
            <el-table-column prop="total" label="总数" width="80" />
            <el-table-column prop="unprocessed" label="未处理" width="90" />
            <el-table-column prop="reserved" label="已占用" width="90" />
            <el-table-column prop="reserved_expired" label="占用(超时)" width="110" />
            <el-table-column prop="completed" label="已完成" width="90" />
            <el-table-column prop="failed" label="失败" width="80" />
            <el-table-column label="操作" width="280" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="gotoDetail(scope.row.batch_code)">详情</el-button>

                <el-dropdown @command="cmd => resetBatch(scope.row.batch_code, cmd)">
                  <el-button type="warning" size="mini" style="margin-left:6px">
                    批量重置<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="unprocessed">重置为未处理</el-dropdown-item>
                    <el-dropdown-item command="completed">重置为已完成</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-popconfirm title="物理删除该批次？" @confirm="deleteBatch(scope.row.batch_code)">
                  <el-button slot="reference" type="danger" size="mini" style="margin-left:6px">删除批次</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <!-- 导出面板 -->
        <el-card style="margin-top:12px;">
          <div slot="header" class="flex">
            <span>导出账号</span>
          </div>
          <el-form :inline="true" :model="exportForm" size="small">
            <el-form-item label="导出范围">
              <el-radio-group v-model="exportForm.scope">
                <el-radio label="all">全部</el-radio>
                <el-radio label="completed">已完成</el-radio>
                <el-radio label="unprocessed">未处理</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="批号">
              <el-select v-model="exportForm.batchCodes" multiple filterable placeholder="不选=所有批次"
                style="min-width:320px">
                <el-option v-for="b in batches" :key="b.batch_code" :label="b.batch_code" :value="b.batch_code" />
              </el-select>
            </el-form-item>

            <el-form-item v-if="exportForm.scope === 'completed'" label="时间段">
              <el-date-picker v-model="exportForm.daterange" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" icon="el-icon-download" @click="doExport" :loading="exporting">导出</el-button>
              <span v-if="exportResult" class="hint">文件：{{ exportResult.file }}（共 {{ exportResult.line_count }}
                行）</span>
            </el-form-item>
          </el-form>
          <div class="muted" style="margin-top:8px;">

          </div>
        </el-card>

        <el-card style="margin-top:12px;">
          <div slot="header" class="flex">
            <span>外部程序调用</span>
            <div>
              <el-button size="mini" @click="fetchProgramToken">刷新</el-button>
              <el-button size="mini" type="primary" @click="rotateProgramToken" :loading="rotatingProgramToken">
                {{ programTokenInfo.exists ? '重新生成 Token' : '创建 Token' }}
              </el-button>
            </div>
          </div>

          <el-alert
            title="给外部程序调用 /accounts/pick-one 和 /accounts/state 使用，请在请求头里带 X-Program-Token。"
            type="info"
            :closable="false"
            show-icon
          />

          <el-descriptions :column="1" size="small" border style="margin-top:12px;">
            <el-descriptions-item label="Header 名称">X-Program-Token</el-descriptions-item>
            <el-descriptions-item label="当前 Token">
              <div v-if="programTokenInfo.exists" class="token-line">
                <span class="token-text">{{ programTokenInfo.token }}</span>
                <el-button type="text" size="mini" @click="copy(programTokenInfo.token)">复制</el-button>
              </div>
              <span v-else class="muted">还没有创建 Program Token</span>
            </el-descriptions-item>
            <el-descriptions-item label="最后使用时间">{{ fmt(programTokenInfo.last_used_at) || '-' }}</el-descriptions-item>
            <el-descriptions-item label="最后更新时间">{{ fmt(programTokenInfo.updated_at) || '-' }}</el-descriptions-item>
          </el-descriptions>

          <el-divider>调用文档</el-divider>

          <div class="doc-block">
            <div class="doc-title">1. 提取一个账号</div>
            <pre class="code-block"><code>{{ pickOneCurl }}</code></pre>
            <pre class="code-block"><code>{{ pickOneJson }}</code></pre>
          </div>

          <div class="doc-block">
            <div class="doc-title">2. 更新账号状态</div>
            <pre class="code-block"><code>{{ stateCurl }}</code></pre>
            <pre class="code-block"><code>{{ stateJson }}</code></pre>
          </div>

          <div class="doc-block">
            <div class="doc-title">状态说明</div>
            <div class="muted">`completed` 表示运行成功，`failed` 表示运行失败，`unprocessed` 表示放回待处理队列。</div>
            <div class="muted">建议外部程序提取成功后，在租约超时前调用 `/accounts/state` 回写最终状态。</div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api, { API_BASE } from '@/api/http'
import { getAuthHeader } from '@/auth'


export default {
  name: 'Dashboard',
  data() {
    return {
      leftTab: 'upload',
      loading: false,
      batches: [],
      global: { total: 0, unprocessed: 0, reserved: 0, reserved_expired: 0, completed: 0, failed: 0 },
      lastUpload: null,

      // 提取&处理
      pickForm: { batchCode: '', leaseSeconds: 600 },
      current: { id: null, email: '', batch_id: null, state: '', lease_expire_at: null },
      failReason: '',
      picking: false,
      marking: false,
      leaseRemain: 0,
      leaseTimer: null,

      // 按邮箱重置
      emailReset: { email: '', state: '' },

      // 导出
      exportForm: { scope: 'all', batchCodes: [], daterange: [] },
      exporting: false,
      exportResult: null,

      // 外部程序 token
      programTokenInfo: { exists: false, token: '', last_used_at: '', updated_at: '' },
      rotatingProgramToken: false
    }
  },
  computed: {
    uploadUrl() {
      return API_BASE + '/upload'
    },
    uploadHeaders() {
      return getAuthHeader()
    },
    docsApiBase() {
      return API_BASE || window.location.origin
    },
    pickOneCurl() {
      const token = this.programTokenInfo.token || '<YOUR_PROGRAM_TOKEN>'
      return `curl -X POST "${this.docsApiBase}/accounts/pick-one" \\
  -H "Content-Type: application/json" \\
  -H "X-Program-Token: ${token}" \\
  -d '{
    "batch_code": "",
    "lease_seconds": 600
  }'`
    },
    pickOneJson() {
      return `成功响应:
{
  "code": 1,
  "message": "ok",
  "data": {
    "id": 123,
    "email": "example@gmail.com",
    "batch_id": 8,
    "state": "reserved",
    "reserved_at": "2026-04-18T11:50:00Z",
    "lease_expire_at": "2026-04-18T12:00:00Z"
  }
}

无可用账号:
{
  "code": 0,
  "message": "no account available",
  "data": null
}`
    },
    stateCurl() {
      const token = this.programTokenInfo.token || '<YOUR_PROGRAM_TOKEN>'
      return `curl -X POST "${this.docsApiBase}/accounts/state" \\
  -H "Content-Type: application/json" \\
  -H "X-Program-Token: ${token}" \\
  -d '{
    "email": "example@gmail.com",
    "state": "completed",
    "lease_check": true,
    "fail_reason": ""
  }'`
    },
    stateJson() {
      return `成功响应:
{
  "code": 1,
  "message": "updated",
  "data": {
    "email": "example@gmail.com",
    "state": "completed"
  }
}

失败示例:
{
  "code": 0,
  "message": "lease expired; cannot update state",
  "data": null
}`
    }
  },
  created() { this.fetchStatus(); this.fetchProgramToken() },
  beforeDestroy() { this.stopLeaseTimer() },
  methods: {
    // -------- 公共 --------
    fmt(iso) { return iso ? new Date(iso).toLocaleString() : '' },
    copy(text) {
      const ta = document.createElement('textarea')
      ta.value = text
      document.body.appendChild(ta)
      ta.select()
      document.execCommand('copy')
      document.body.removeChild(ta)
      this.$message.success('已复制')
    },

    // -------- 状态板 --------
    async fetchStatus() {
      this.loading = true
      try {
        const { data } = await api.get('/status')
        if (data && data.code === 1) {
          this.batches = data.data.batches || []
          this.global = data.data.global || this.global
        } else {
          this.$message.error(data.message || '获取状态失败')
        }
      } catch (e) {
        this.$message.error('网络错误')
      } finally {
        this.loading = false
      }
    },
    async fetchProgramToken() {
      try {
        const { data } = await api.get('/program-token')
        if (data && data.code === 1) {
          this.programTokenInfo = data.data || this.programTokenInfo
        } else {
          this.$message.error(data.message || '获取 Program Token 失败')
        }
      } catch (e) {
        this.$message.error('网络错误')
      }
    },
    async rotateProgramToken() {
      this.rotatingProgramToken = true
      try {
        const { data } = await api.post('/program-token/rotate', {})
        if (data && data.code === 1) {
          this.programTokenInfo = Object.assign({ exists: true }, data.data || {})
          this.$message.success('Program Token 已生成')
        } else {
          this.$message.error(data.message || '生成 Program Token 失败')
        }
      } catch (e) {
        this.$message.error('网络错误')
      } finally {
        this.rotatingProgramToken = false
      }
    },
    async reapLeases() {
      try {
        const { data } = await api.post('/leases/reap', {})
        if (data.code === 1) {
          this.$message.success(`已回收：${data.data.affected}`)
          this.fetchStatus()
        } else {
          this.$message.error(data.message || '回收失败')
        }
      } catch (e) {
        this.$message.error('网络错误')
      }
    },
    async deleteBatch(code) {
      try {
        const { data } = await api.delete(`/batches/${encodeURIComponent(code)}?force=true`)
        if (data.code === 1) {
          this.$message.success('批次已删除')
          this.fetchStatus()
        } else {
          this.$message.error(data.message || '删除失败')
        }
      } catch (e) {
        this.$message.error('网络错误')
      }
    },
    gotoDetail(code) {
      this.$router.push({ name: 'batchDetail', params: { code } })
    },
    async resetBatch(code, target) {
      if (!['completed', 'unprocessed'].includes(target)) return
      try {
        const { data } = await api.post(`/batches/${encodeURIComponent(code)}/reset-state`, { state: target })
        if (data.code === 1) {
          this.$message.success(`批量重置完成（${data.data.affected} 条）`)
          this.fetchStatus()
        } else {
          this.$message.error(data.message || '批量重置失败')
        }
      } catch (e) {
        this.$message.error('网络错误')
      }
    },

    // -------- 上传 --------
    onUploadSuccess(res) {
      if (res && res.code === 1) {
        this.leftTab = 'pick'
        this.lastUpload = res.data
        this.$message.success('上传成功')
        this.fetchStatus()
      } else {
        this.$message.error(res.message || '上传失败')
      }
    },
    onUploadError() { this.$message.error('上传失败') },

    // -------- 提取&回写 --------
    async pickOne() {
      this.picking = true
      try {
        const payload = {}
        if (this.pickForm.batchCode.trim()) payload.batch_code = this.pickForm.batchCode.trim()
        if (this.pickForm.leaseSeconds && this.pickForm.leaseSeconds > 0) payload.lease_seconds = this.pickForm.leaseSeconds

        const { data } = await api.post('/accounts/pick-one', payload)
        if (data.code === 1 && data.data) {
          this.current = {
            id: data.data.id,
            email: data.data.email,
            batch_id: data.data.batch_id,
            state: data.data.state,
            lease_expire_at: data.data.lease_expire_at
          }
          this.$message.success('已提取一个账号')
          this.startLeaseTimer()
          this.fetchStatus()
        } else {
          this.$message.warning(data.message || '没有可提取的账号')
        }
      } catch (e) {
        this.$message.error('网络错误')
      } finally { this.picking = false }
    },
    async markCompleted() {
      if (!this.current.email) return
      this.marking = true
      try {
        const { data } = await api.post('/accounts/state', {
          email: this.current.email,
          state: 'completed',
          lease_check: true
        })
        if (data.code === 1) {
          this.$message.success('已标记完成')
          this.clearCurrent()
          this.fetchStatus()
        } else {
          this.$message.error(data.message || '标记失败')
        }
      } catch (e) { this.$message.error('网络错误') }
      finally { this.marking = false }
    },
    async markFailed() {
      if (!this.current.email) return
      this.marking = true
      try {
        const { data } = await api.post('/accounts/state', {
          email: this.current.email,
          state: 'failed',
          lease_check: true,
          fail_reason: this.failReason || undefined
        })
        if (data.code === 1) {
          this.$message.success('已标记失败')
          this.clearCurrent()
          this.fetchStatus()
        } else {
          this.$message.error(data.message || '标记失败')
        }
      } catch (e) { this.$message.error('网络错误') }
      finally { this.marking = false }
    },
    async resetUnprocessed() {
      if (!this.current.email) return
      try {
        const { data } = await api.post('/accounts/state', {
          email: this.current.email,
          state: 'unprocessed',
          lease_check: false
        })
        if (data.code === 1) {
          this.$message.success('已重置为未处理')
          this.clearCurrent()
          this.fetchStatus()
        } else {
          this.$message.error(data.message || '重置失败')
        }
      } catch (e) { this.$message.error('网络错误') }
    },
    clearCurrent() {
      this.current = { id: null, email: '', batch_id: null, state: '', lease_expire_at: null }
      this.failReason = ''
      this.stopLeaseTimer()
      this.leaseRemain = 0
    },
    startLeaseTimer() { this.stopLeaseTimer(); this.tickLease(); this.leaseTimer = setInterval(this.tickLease, 1000) },
    stopLeaseTimer() { if (this.leaseTimer) { clearInterval(this.leaseTimer); this.leaseTimer = null } },
    tickLease() {
      if (!this.current.lease_expire_at) return (this.leaseRemain = 0)
      const end = new Date(this.current.lease_expire_at).getTime()
      const now = Date.now()
      const remain = Math.floor((end - now) / 1000)
      this.leaseRemain = remain > 0 ? remain : 0
    },

    // -------- 按邮箱重置 --------
    async resetEmail() {
      const email = (this.emailReset.email || '').trim()
      const state = (this.emailReset.state || '').trim()
      if (!email || !state) return
      try {
        const { data } = await api.post('/accounts/state', {
          email,
          state,
          lease_check: false
        })
        if (data.code === 1) {
          this.$message.success('已按邮箱重置')
          if (this.current.email === email) this.clearCurrent()
          this.fetchStatus()
        } else {
          this.$message.error(data.message || '重置失败')
        }
      } catch (e) { this.$message.error('网络错误') }
    },

    // -------- 导出 --------
    // 在 methods 里的 doExport() 替换为：
    async doExport() {
      this.exporting = true
      try {
        let url = '/export/all'
        const body = { batch_codes: this.exportForm.batchCodes }
        if (this.exportForm.scope === 'completed') {
          url = '/export/completed'
          if (this.exportForm.daterange && this.exportForm.daterange.length === 2) {
            body.start = this.exportForm.daterange[0]
            body.end = this.exportForm.daterange[1]
          }
        } else if (this.exportForm.scope === 'unprocessed') {
          url = '/export/unprocessed'
        }
        const { data } = await api.post(url, body)
        if (data.code === 1) {
          this.exportResult = data.data
          let dl = data.data.path || data.data.url
          if (!dl) {
            this.$message.error('后端未返回下载地址'); return
          }
          if (dl.startsWith('/')) dl = API_BASE + dl
          const fileRes = await api.get(dl, { responseType: 'blob' })
          const blobUrl = window.URL.createObjectURL(new Blob([fileRes.data]))
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = data.data.file || 'export.txt'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(blobUrl)

          this.$message.success('导出开始下载')
        } else {
          this.$message.error(data.message || '导出失败')
        }
      } catch (e) {
        this.$message.error('网络错误')
      } finally {
        this.exporting = false
      }
    }

  }
}
</script>

<style scoped>
.p {
  padding: 12px;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hint {
  color: #999;
  margin-left: 8px;
}

.muted {
  color: #888;
}

.token-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.token-text {
  word-break: break-all;
  font-family: Consolas, Monaco, monospace;
}

.doc-block {
  margin-top: 12px;
}

.doc-title {
  margin-bottom: 8px;
  font-weight: 600;
}

.code-block {
  margin: 8px 0 0;
  padding: 12px;
  overflow-x: auto;
  background: #f5f7fa;
  border-radius: 6px;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
}
</style>
